<template>
	<div>
		<v-head :title="title" :route="'MeetingList'"></v-head>
		<div class="group_1 flex-col">
			<div class="group_2 flex-col">
				<van-pull-refresh v-model="Loading" @refresh="onfresh">
					<div class="warmTips" v-if="List && !List.length && !loading">
						<img src="../../../assets/images/empty-image-default.png" />
						<span>暂无内容</span>
					</div>
					<div v-else>
						<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
							<div class="box_1 flex-col" v-for="(item, index) in List" :key="index">
								<div>
									<div class="section_1 flex-row justify-between">
										<span class="text_1">{{ item.meeting.name }}</span>

										<div v-if="
                      item.meetingRegister.meetingRegisterStatus ==
                        '6'
                    " class="tag_1 flex-col">
											<span class="text_2">付款审核中</span>
										</div>
										<div v-if="
                      item.meetingRegister.meetingRegisterStatus ==
                        '5'
                    " class="tag_1 flex-col">
											<span class="text_2">待付款</span>
										</div>
										<div v-if="
                      item.meetingRegister.meetingRegisterStatus ==
                        '2'
                    " class="tag_3 flex-col">
											<span class="text_2">报名成功</span>
										</div>
										<div v-if="
                      item.meetingRegister.meetingRegisterStatus ==
                        '3'
                    " class="tag_4 flex-col">
											<span class="text_2">已取消</span>
										</div>
									</div>
									<div class="image-text_1 flex-row justify-between">
										<van-icon name="notes-o" class="icon_1" />

										<div class="text-group_1">
											<span class="text_3">举办时间：</span>
											<span class="text_21">
												{{ item.meeting.startDate | changeTime }}至{{
												item.meeting.endDate | changeTime
												}}</span>
										</div>
									</div>
									<div class="box_4 flex-row justify-between">
										<div class="image-text_6 flex-row justify-between">
											<van-icon name="underway-o" class="icon_5" />

											<div class="text-group_6">
												<span class="text_20">报名时间：</span>
												<span class="text_21">
													{{ item.meeting.registerStartDate | changeTime }}至{{
													item.meeting.registerEndDate | changeTime
													}}</span>
											</div>
										</div>
									</div>

								</div>
								<!-- 酒店信息提示 -->
								<div v-if="item.meetingRegister.message" class=" flex-row ">
									<span class="errtext">{{ item.meetingRegister.message}}</span>
								</div>
								<!-- 已取消 -->
								<div v-if="
                  item.meetingRegister.meetingRegisterStatus == 7 &&
                    item.auditFailedReason
                " class=" flex-row ">
									<span class="errtext">退回原因：{{ item.auditFailedReason }}</span>
								</div>
								<div v-if="item.meetingRegister.meetingRegisterStatus == 3" class="section_3 flex-row ">
									<button class="button_3 flex-col" @click="reRegister(item)">
										<span class="text_15">重新报名</span>
									</button>
								</div>
								<!-- 报名成功 -->
								<div v-if="
                  item.meetingRegister.meetingRegisterStatus == 2
                ">
									<div class="section_3 flex-row ">
										<button v-if="item.meeting.id != '89b92404-633e-4e0a-8729-eeb7a00e1d60'"
											class="button_3 flex-col" @click="change(item)">
											<span class="text_15">修改</span>
										</button>
									</div>
								</div>
								<!-- 待付款 -->
								<div v-if="
                  item.meetingRegister.meetingRegisterStatus == 5 &&
                    item.meetingRegister.failedReason
                " class=" flex-row ">
									<span class="errtext">退回原因：{{ item.meetingRegister.failedReason }}</span>
								</div>
								<div v-if="
                  item.meetingRegister.meetingRegisterStatus == 5
                 ">
									<div class="section_3 flex-row ">
										<button class="button_3 flex-col" @click="cancel(item)">
											<span class="text_15">取消报名</span>
										</button>
										<button v-if="item.meeting.id != '89b92404-633e-4e0a-8729-eeb7a00e1d60'"
											class="button_3 flex-col" @click="change(item)">
											<span class="text_15">修改</span>
										</button>
										<button v-if="item.orderInfo && item.orderInfo.orderStatus == 2" class="button_3 flex-col"
											@click="gotoPay(item)">
											<span class="text_15">去支付</span>
										</button>
									</div>
								</div>

								<van-divider />
							</div>
						</van-list>
					</div>
				</van-pull-refresh>
			</div>
		</div>
	</div>
</template>

<script>
	import { Icon, Loading, List, Dialog, Toast, PullRefresh, Divider, } from "vant"
	import { mapGetters, mapMutations } from "vuex"
	import {
		registerPage,
		cancelRegister,
	} from "../../../api/dictionary"
	import vHead from "../../../components/Subhead.vue"
	export default {
		props: {
			type: {
				type: String,
			},
		},
		data() {
			return {
				title: '报名状态查询',
				constants: {},
				loading: false,
				Loading: false,
				finished: false,
				page: 0,
				List: [],
			}
		},
		components: {
			vHead,
			[Icon.name]: Icon,
			[Loading.name]: Loading,
			[List.name]: List,
			[Dialog.name]: Dialog,
			[Toast.name]: Toast,
			[PullRefresh.name]: PullRefresh,
			[Divider.name]: Divider,
		},
		computed: {
			dataout(time) {
				let now = new Date()
				let Endtime = new Date(time)
				return now > Endtime ? "true" : "false"
			},
		},
		methods: {
			// 申请退款
			refund(item) {
				console.log("item", item)
				this.$router.push({
					name: "signuppayRefund",
					query: {
						orderNo: item.orderInfo.orderNo,
						meetingRegisterId: item.meetingRegister.id,
						route: this.type,
					},
				})
			},
			change(item) {
				sessionStorage.setItem(
					"meetingRegisterList",
					JSON.stringify(item.meetingRegisterList)
				)
				this.$router.push({
					name: "changePage",
					query: {
						meetingId: item.meeting.id,
						meetingRegisterId: item.meetingRegister.id,
						loginStatus: true
					},
				})
			},
			onLoad() {
				console.log("onload")
				// 异步更新数据
				if (this.finished == true) return
				let params = {
					memberId: sessionStorage.getItem("memberId")
				}
				this.page = this.page + 1
				registerPage(params, this.page)
					.then((res) => {
						if (res.success) {
							if (res.result.content.length > 0) {
								this.List.push(...res.result.content)
							}
						}
						if (this.List.length >= res.result.totalElements) {
							this.finished = true
						}
					})
					.catch(() => {
						Toast.fail("获取数据失败")
					})
					.finally(() => {
						this.loading = false
					})
			},
			onfresh() {
				console.log("refesh")
				this.page = 0
				let params = {
					memberId: sessionStorage.getItem("memberId"),
				}
				this.List = []
				registerPage(params, this.page)
					.then((res) => {
						if (res.success) {
							if (res.result.content.length > 0) {
								this.List = res.result.content
							}
						}
					})
					.catch(() => {
						Toast.fail("获取数据失败")
					})
					.finally(() => {
						this.Loading = false
					})
			},
			getData() {
				let params = {
					memberId: sessionStorage.getItem("memberId"),
				}
				registerPage(params, this.page)
					.then((res) => {
						if (res.success) {
							if (res.result.content.length > 0) {
								this.List.push(...res.result.content)
							}
						}
					})
					.catch(() => {
						Toast.fail("获取数据失败")
					})
					.finally(() => {
						this.loading = false
					})
			},
			reRegister(item) {
				//报名页
				this.$router.push({
					name: "signup",
					query: {
						meetingId: item.meeting.id,
						loginStatus: true,
						meetingRegisterId: item.meetingRegister.id,
						reRegister: true
					},
				})
			},
			goDetail(item) {
				this.$router.push({
					name: "signuppayDetail",
					query: {
						id: item.meeting.id,
						meetingRegisterId: item.meetingRegister.id,
						route: this.type,
					},
				})
			},
			gotoPay(item) {
				this.$router.push({
					name: "Paypage",
					query: {
						orderId: item.orderInfo.id,
						amount: item.orderInfo.amount,
						orderNo: item.orderInfo.orderNo,
						sourceName: "SignUpmeetingCenter",
					},
				})
			},
			cancel(item) {
				Dialog.confirm({
					title: "提示",
					message: "确定取消报名吗？",
					confirmButtonColor: " rgba(246, 109, 17, 1)",
				})
					.then(() => {
						let params = {
							id: item.meetingRegister.id,
							// meetingRegisterStatus: "3",
						}
						cancelRegister(params).then((res) => {
							if (res.success) {
								this.onLoad()
								Toast.success("取消成功")
								this.$router.push({
									name: "SignUpmeetingCenter",
									query: { type: this.type },
								})
								this.onfresh()
							} else {
								Toast.fail(res.message)
							}
						})
					})
					.catch(() => {
						// on cancel
					})
			},
		},
		mounted() {
			this.getData()
		},
	}
</script>
<style scoped lang="less">
	.page {
		position: relative;
		height: 100%;
		/* overflow-y: scroll; */
		/* overflow: hidden; */
	}

	/deep/.van-dialog {
		color: rgba(246, 109, 17, 1);
	}

	/* /deep/.van-list {
  height: 896px;
  overflow: scroll;
} */
	.warmTips {
		margin: 30px 0 0 0;
		padding-top: 45%;
	}

	.image-wrapper_1 {
		background-color: rgba(255, 255, 255, 1);
		padding: 18px 16px 13px 37px;
	}

	.errtext {
		margin-top: 10px;
		left: 40px;
		top: 2266px;
		width: 318px;
		max-height: 30px;
		border: 0.3px solid rgba(234, 15, 15, 1);
		line-height: 20px;
		border-radius: 3px;
		font-weight: 50;
		padding: 6px 0px 10px 10px;
		color: rgba(234, 15, 15, 1);
		font-size: 14px;
		text-align: left;
		font-family: PingFangSC-regular;
		word-wrap: break-word;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.section_1 {
		width: 100%;
	}

	.group_1 {
		height: 100%;
		padding: 0 8px 0 8px;
	}

	.box_1 {
		background-color: rgba(255, 255, 255, 1);
		border-radius: 4px;
		padding: 0 10px;
		margin-top: 10px;
	}

	.image-text_1 {
		width: 245px;
		margin: 16px 125px 0 0;
		color: #888;
	}

	.icon_1 {
		font-size: 13px;
		margin: 3px auto;
	}

	.text-group_1 {
		width: 223px;
		height: 20px;
		overflow-wrap: break-word;
		font-size: 0;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_3 {
		overflow-wrap: break-word;
		color: rgba(136, 136, 136, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_4 {
		overflow-wrap: break-word;
		color: rgba(26, 26, 26, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_1 {
		overflow-wrap: break-word;
		color: rgba(26, 26, 26, 1);
		font-size: 16px;
		width: 240px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		font-weight: NaN;
		text-align: left;
		line-height: 22px;
	}

	.tag_1 {
		/* background: url(../assets/images/user/baci.png) 100% no-repeat; */
		height: 18px;
		background-size: 100% 22px;
		color: rgba(255, 31, 51, 1);
		padding: 0px 3px 2px 8px;
	}

	.tag_3 {
		/* background: url(../assets/images/user/bac2.png) 100% no-repeat; */
		height: 22px;
		background-size: 100% 22px;
		color: rgba(0, 183, 0, 1);
		padding: 2px 3px 2px 8px;
	}

	.tag_4 {
		/* background: url(../assets/images/user/bac3.png) 100% no-repeat; */
		color: rgba(75, 89, 107, 1);
		height: 22px;
		background-size: 100% 22px;
		padding: 2px 3px 3px 8px;
	}

	.tag_2 {
		/* background: url(../assets/images/user/bac3.png) 100% no-repeat; */
		height: 22px;
		background-size: 100% 22px;
		color: rgba(132, 144, 157, 1);
		padding: 2px 3px 2px 8px;
	}

	.text_2 {
		overflow-wrap: break-word;
		font-size: 12px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 17px;
		height: 100%;
		display: flex;
		align-items: center;
	}

	.box_4 {
		margin-left: 1px;
	}

	.image-text_6 {
		color: #888;
		width: 245px;
		margin-top: 16px;
	}

	.icon_5 {
		font-size: 13px;
		margin: 3px auto;
	}

	.text-group_6 {
		width: 223px;
		height: 20px;
		overflow-wrap: break-word;
		font-size: 0;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_20 {
		overflow-wrap: break-word;
		color: rgba(136, 136, 136, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_21 {
		overflow-wrap: break-word;
		color: rgba(26, 26, 26, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.button_4 {
		background-size: 100% 100%;
		margin-bottom: 14px;
		padding: 2px 12px 1px 13px;
	}

	.text_22 {
		overflow-wrap: break-word;
		color: #00d079;
		font-size: 12px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 17px;
	}

	.image-text_3 {
		color: #888;
		width: 157px;
		margin: 16px 213px 0 0;
	}

	.icon_3 {
		width: 14px;
		height: 17px;
		margin: 2px 0 1px 0;
	}

	.text-group_3 {
		width: 135px;
		height: 20px;
		overflow-wrap: break-word;
		font-size: 0;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_7 {
		overflow-wrap: break-word;
		color: rgba(136, 136, 136, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_8 {
		overflow-wrap: break-word;
		color: rgba(26, 26, 26, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.section_2 {
		margin: 16px 16px 0 0;
	}

	.image-text_4 {
		color: #888;
		width: 101px;
		margin-bottom: 21px;
	}

	.thumbnail_3 {
		width: 19px;
		height: 17px;
		margin: 1px 0 2px 0;
	}

	.text-group_4 {
		width: 79px;
		height: 20px;
		overflow-wrap: break-word;
		font-size: 0;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_9 {
		overflow-wrap: break-word;
		color: rgba(136, 136, 136, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_10 {
		overflow-wrap: break-word;
		color: rgba(26, 26, 26, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text-wrapper_1 {
		height: 25px;
		overflow-wrap: break-word;
		font-size: 0;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
		margin-top: 16px;
	}

	.text_11 {
		height: 25px;
		overflow-wrap: break-word;
		color: rgba(136, 136, 136, 1);
		font-size: 14px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.text_12 {
		overflow-wrap: break-word;
		color: #00d079;
		font-size: 18px;
		font-family: PingFangSC-Semibold;
		font-weight: 600;
		text-align: left;
		white-space: nowrap;
		line-height: 20px;
	}

	.section_3 {
		margin: 16px 0 0 0;
		justify-content: end;
	}

	.button_1 {
		background-color: rgba(255, 255, 255, 1);
		border-radius: 28px;
		border: 1px solid rgba(230, 230, 232, 1);
		padding: 5px 15px 4px 15px;
		margin-right: 6px;
	}

	.text_13 {
		overflow-wrap: break-word;
		color: rgba(136, 136, 136, 1);
		font-size: 12px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 17px;
	}

	.button_2 {
		background-color: #00d079;
		border-radius: 28px;
		padding: 5px 9px 4px 9px;
		margin-right: 6px;
	}

	.text_14 {
		overflow-wrap: break-word;
		color: rgba(255, 255, 255, 1);
		font-size: 12px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 17px;
	}

	.button_3 {
		background-color: rgba(255, 255, 255, 1);
		border-radius: 28px;
		border: 1px solid #00d079;
		padding: 5px 15px 4px 15px;
		margin-right: 6px;
	}

	.button_3:active {
		background-color: #00d079;
		border-radius: 28px;
		padding: 5px 15px 4px 15px;
		margin-right: 6px;
	}

	.text_15 {
		overflow-wrap: break-word;
		color: #00d079;
		font-size: 12px;
		font-weight: NaN;
		text-align: left;
		white-space: nowrap;
		line-height: 17px;
	}

	.text_15:active {
		color: #fff;
	}

	.justify-between {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: justify;
		-webkit-justify-content: space-between;
		justify-content: space-between;
	}

	.flex-row {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		flex-direction: row;
	}
</style>
